import fetch from 'lib/fetch'
import { getCustomersByWorkspaceSlug } from 'selectors'
import { createAction } from 'redux-actions'
import qs from 'qs'

export const REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS'
export const REQUEST_CUSTOMERS_ERROR = 'REQUEST_CUSTOMERS_ERROR'
export const RECEIVE_CUSTOMERS = 'RECEIVE_CUSTOMERS'

export const REQUEST_CUSTOMER = 'REQUEST_CUSTOMER'
export const RECEIVE_CUSTOMER = 'RECEIVE_CUSTOMER'
export const REQUEST_CUSTOMER_ERROR = 'REQUEST_CUSTOMER_ERROR'

export const REQUEST_FIND_CUSTOMERS = 'REQUEST_FIND_CUSTOMERS'
export const RECEIVE_FIND_CUSTOMERS = 'RECEIVE_FIND_CUSTOMERS'
export const REQUEST_FIND_CUSTOMERS_ERROR = 'REQUEST_FIND_CUSTOMERS_ERROR'

export const SET_SEARCHING_FOR_CUSTOMERS = 'SET_SEARCHING_FOR_CUSTOMERS'
export const SET_CUSTOMER_TRAITS_SEARCH_TERM = 'SET_CUSTOMER_TRAITS_SEARCH_TERM'
export const SET_CUSTOMER_EVENTS_SEARCH_TERM = 'SET_CUSTOMER_EVENTS_SEARCH_TERM'
export const SET_CUSTOMER_EVENTS_FILTER = 'SET_CUSTOMER_EVENTS_FILTER'

export const setSearchingForCustomers = createAction(SET_SEARCHING_FOR_CUSTOMERS)
export const setCustomerTraitsSearchTerm = createAction(SET_CUSTOMER_TRAITS_SEARCH_TERM)
export const setCustomerEventsSearchTerm = createAction(SET_CUSTOMER_EVENTS_SEARCH_TERM)
export const setCustomerEventsFilter = createAction(SET_CUSTOMER_EVENTS_FILTER)

export const fetchCustomers = (workspaceSlug, next) => ({
  types: {
    request: REQUEST_CUSTOMERS,
    receive: RECEIVE_CUSTOMERS,
    failure: REQUEST_CUSTOMERS_ERROR
  },
  payload: { workspaceSlug },
  shouldCallAPI: state => {
    const customers = getCustomersByWorkspaceSlug(state, workspaceSlug)
    if (!customers) return true
    return !customers.isRequesting
  },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/customers?limit=100${next ? '&next=' + next : ''}`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch customers')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const fetchCustomer = (workspaceSlug, id) => ({
  types: {
    request: REQUEST_CUSTOMER,
    receive: RECEIVE_CUSTOMER,
    failure: REQUEST_CUSTOMER_ERROR
  },
  payload: { workspaceSlug, id },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/customers/${id}`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch customer')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const findUser = (workspaceSlug, query) => ({
  types: {
    request: REQUEST_FIND_CUSTOMERS,
    receive: RECEIVE_FIND_CUSTOMERS,
    failure: REQUEST_FIND_CUSTOMERS_ERROR
  },
  payload: { workspaceSlug },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/customers/find?${qs.stringify(query)}`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to find customer')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})



// WEBPACK FOOTER //
// ./actions/customers.js